import { call, put, takeEvery, select } from 'redux-saga/effects'
import vehicleActionsTypes from '../../../../constants/actions/dossier/common/vehicle'
import { change } from 'redux-form'
import { showLoader, hideLoader } from '../../../../actions/common'
import { getAuth } from '../../../../selectors/access/auth'
import { handleError } from '../../../errors/errorManager'
import { dossierSubTypeId as dossierSubTypeIdConstants } from '../../../../constants/dossier/common/dossierSubType'
import getVehicleDestinationCombo from '../../../../services/vehicle/getVehicleDestinationCombo'
import { fetchCombosSuccess } from '../../../../actions/combos/combos'

export function * fetchComboDestination ({ comercialCode, dossierSubType }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    var combo = null
    if (comercialCode.length >= 8) {
      var modifiedCode = comercialCode.substring(4, 8)
      combo = yield call(getVehicleDestinationCombo, auth.token, modifiedCode)
    }
    yield put(fetchCombosSuccess({ vehicleDestinationCombo: combo }))
    if (combo && combo.length === 1 && dossierSubType === dossierSubTypeIdConstants.venta_vn) {
      yield put(change('salesDossier', 'vehicleComponent.destinationId', combo[0].id))
    }
  } catch (error) {
    const sessionHandler = function * () {}
    yield call(handleError, { error, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchComboDestination () {
  yield takeEvery(vehicleActionsTypes.FETCH_COMBO_DESTINATION, fetchComboDestination)
}
